import { api } from './client';

export interface FxRates {
  /** 1 CNY = rates[X] 个 X。 */
  rates: Record<string, number>;
  fetchedAt: string;
}

export async function getFxRates() {
  const { data } = await api.post<FxRates>('/fx/rates', {});
  return data;
}
